import { Injectable } from '@angular/core';

import { HTTPHelperService } from './http-helper.services';

@Injectable()
export class SecureService {

    constructor(private httpHelper: HTTPHelperService) {

    }
    public login({ url, params }) {
        return this.httpHelper.postWitoutHeaderFunction({ url: url, params: params });
    }
}
